/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantImpersonation } from '../../models/merchant-impersonation';

export interface ApiTicketItemIdMerchantIdImpersonateTokenGet$Params {
  item_id: number;
  merchant_id: number;
}

export function apiTicketItemIdMerchantIdImpersonateTokenGet(http: HttpClient, rootUrl: string, params: ApiTicketItemIdMerchantIdImpersonateTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantImpersonation>> {
  const rb = new RequestBuilder(rootUrl, apiTicketItemIdMerchantIdImpersonateTokenGet.PATH, 'get');
  if (params) {
    rb.path('item_id', params.item_id, {});
    rb.path('merchant_id', params.merchant_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantImpersonation>;
    })
  );
}

apiTicketItemIdMerchantIdImpersonateTokenGet.PATH = '/api/ticket/{item_id}/{merchant_id}/impersonate-token';
